import { render, staticRenderFns } from "./PaidCustodyCompleted.vue?vue&type=template&id=2793d9ac&scoped=true"
import script from "./PaidCustodyCompleted.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaidCustodyCompleted.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PaidCustodyCompleted.vue?vue&type=style&index=0&id=2793d9ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2793d9ac",
  null
  
)

export default component.exports